import axios from 'axios'

export default {
  getGalleryFiles() {
    return axios.get('/api/files/gallery')
  },
  uploadGalleryFiles(files) {
    const fd = new FormData()
    for (let i = 0; i < files.length; i += 1) {
      fd.append('file', files[i], files[i].name)
    }
    return axios.post('/api/files/gallery', fd)
  },
  deleteGalleryFile(id) {
    return axios.delete(`/api/files/gallery/${id}`)
  }
}
